/* eslint-disable react/prop-types */
import { Box } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import dayjs from 'dayjs'

const DateInputComp = ({
  label,
  value,
  setValue,
  placeholder,
  isRequired = 0,
  minDate,
  maxDate,
   clearable = true,
  ...props
}) => {
  return (
    <Box>
      <DateInput
        label={label}
        valueFormat='DD-MMM-YYYY'
        placeholder={placeholder}
        value={value}
        withAsterisk={isRequired}
        clearable={clearable}
        onChange={setValue}
        minDate={minDate ? new Date(minDate) : null}
        maxDate={maxDate ? new Date(maxDate) : null}
        styles={{
          levelsGroup: {
            // fixed height to avoid calendar displacement...
            height: 300
          }
        }}
        {...props}
      />
    </Box>
  )
}

export default DateInputComp
